import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import "./FundraisingAltImage.scss";

const FundraisingAltImage = ({ hasActiveGlobalAccount }) => {
    // Only render the hero image above the "My Fundraising Dashboard" button
    // if the user has activated their account
    if (hasActiveGlobalAccount) {
        return (
            <div className="fundraising-alt-image grid">
                <div className="col col--12">
                    <Icon
                        className="fundraising-alt-image__container"
                        glyph="qgiv-fundraising-alt"
                        type="Custom"
                    />
                </div>
            </div>
        );
    }

    return null;
};

FundraisingAltImage.propTypes = {
    hasActiveGlobalAccount: PropTypes.bool.isRequired,
};

export default FundraisingAltImage;
